import { Inline, ShortText } from 'src/viewLayer/components/DesignSystem';

import TextWithInterpolation from 'src/viewLayer/components/shared/TextWithInterpolation';
import { t } from 'src/viewLayer/helpers/translations';
import { Container } from './index.styled';

export default ({ banner }: { banner: { key: string } }): JSX.Element => (
  <Container padding={ 8 }>
    <Inline align="center" alignItems="center" gap={ 12 }>
      <ShortText color="inverse" textAlign="center">
        { TextWithInterpolation({ translationText: t(banner.key) }) }
      </ShortText>
    </Inline>
  </Container>
);
